<ng-container *ngIf="activity && definition">
    <button
        class="task ym-border-0 ym-w-full ym-bg-transparent ym-display-block ym-text-decoration-none ym-focus--focus ym-px-5 ym-py-3 ym-active-shadow-button-inset ym-transition-duration-medium">
        <div class="info-wrapper ym-display-flex ym-gap-3">
            <div class="info ym-display-flex ym-flex-direction-column ym-w-full ym-overflow-hidden">
                <ym-task-checkbox [checked]="activity['is_completed']"
                    [dueTask]="activity['due_date'] < currentTimestamp" [label]="activity['title']"
                    (valueChange)="updateActivityCompleteStatus($event)"></ym-task-checkbox>
                <!-- <h3 class="ym-font-lg ym-font-weight-semibold ym-line-height-20 ym-text-color">Aman
                    <ym-badge [label]="'High'" [type]="badgeTypes.DANGER" [size]="badgeSizes.SM"
                        class="ym-display-inline-block ym-relative ym-bottom-1"></ym-badge>
                </h3> -->
                <p class="ym-display-flex ym-text-secondary ym-gap-2 ym-align-items-center ym-font-sm ym-pl-6">
                    <span class="task-detail ym-line-height-normal ym-white-space-nowrap"
                        *ngIf="activity['task_type']">{{activity['task_type']}}
                        <!-- <span
                                        class="separator ym-w-2 ym-h-2 ym-mb-1 ym-display-inline-block ym-rounded-5 ym-bg-gray-50 ym-ml-1 ym-flex-shrink-0"></span> -->
                        <span class="separator ym-text-gray-100 ym-line-height-normal ym-ml-1 ym-font-lg">•</span>
                    </span>
                    <span class="time ym-line-height-normal ym-white-space-nowrap ym-svg-sm"
                        [title]="activity['due_date'] | dateTime: dateTimeFormats.LONG">
                        <!-- <ym-icon [iconName]="iconNames.CALENDAR" class="ym-mr-1"></ym-icon> -->
                        <ng-container *ngIf="!activity['is_completed']">
                            <!-- Overdue Task -->
                            <span *ngIf="activity['due_date'] < currentTimestamp" class=" ym-text-danger"
                                [title]="activity['due_date'] | dateTime:dateTimeFormats.LONG">
                                Overdue {{ activity['due_date'] | dateTime }}
                            </span>
                            <!-- Upcoming Task -->
                            <span *ngIf="activity['due_date'] >= currentTimestamp"
                                [title]="activity['due_date'] | dateTime:dateTimeFormats.LONG">
                                Due {{ activity['due_date'] | dateTime:dateTimeFormats.SHORT }}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="activity['is_completed']">
                            <span [title]="activity['updated_on'] | dateTime:dateTimeFormats.LONG">
                                {{ activity['due_date'] | dateTime:dateTimeFormats.SHORT }}
                            </span>
                        </ng-container>
                    </span>
                    <!-- <ng-container *ngIf="assignedToUser">
                        <span class="separator ym-text-gray-100 ym-line-height-normal ym-ml-1 ym-font-lg">•</span>
                        <span
                            class="time ym-line-height-normal ym-white-space-nowrap ym-svg-sm ym-overflow-hidden ym-max-w-full ym-text-overflow-ellipsis">
                            <ym-icon [iconName]="iconNames.USER" class="ym-mr-1"></ym-icon>
                            Aman
                        </span>
                    </ng-container> -->
                </p>
            </div>
            <!-- <ym-button [icon]="iconNames.ELLIPSIS" class="ym-mt-1"
                            [variant]="buttonVariants.ICON_ONLY"></ym-button> -->
            <ng-container *ngIf="assignedToUser">
                <app-user-avatar [size]="avatarSizes.BASE" [user]="assignedToUser"></app-user-avatar>
            </ng-container>

        </div>
    </button>
</ng-container>